import {Check, Heart} from "lucide-react";
import {money} from "@/lib/inner";

export const FavoritePackages = ({packages, services, selectedIds, onApply}) => {
  if (!packages.length) return null;
  return <div className="fav-packages" data-testid="favorite-packages">
    <p className="field-label"><Heart size={13}/> Paket favorit <span className="optional">Sekali ketuk</span></p>
    <div className="fav-grid">
      {packages.map(p => {
        const items = p.service_ids.map(id => services.find(s => s.id === id)).filter(Boolean);
        const on = p.service_ids.every(id => selectedIds.includes(id));
        return <button type="button" key={p.id} data-testid={`favorite-package-${p.id}`} className={`fav-card ${on ? "on" : ""}`} onClick={() => onApply(p, on)}>
          <span className="fav-top"><b>{p.name}</b>{on && <Check size={15}/>}</span>
          <small>{items.map(s => s.name).join(" + ")}</small>
          <em>{money(items.reduce((a, s) => a + s.price, 0))}</em>
        </button>;
      })}
    </div>
  </div>;
};
